/** Correspondencia estado → tono. Separado del componente para no romper HMR. */

export type StatusTone = "good" | "warning" | "serious" | "critical" | "neutral";

/** Estado de una corrida → tono. `validating` todavía no es éxito. */
export function runTone(status: string): StatusTone {
  switch (status) {
    case "published":
      return "good";
    case "failed":
      return "critical";
    case "validating":
    case "extracted":
    case "running":
      return "warning";
    default:
      return "neutral";
  }
}

/**
 * Estado de una corrida → texto, en español.
 *
 * El estado se imprimía CRUDO —`published`, `running`, `failed`— en cuatro
 * pantallas de una interfaz que está entera en español, y en el Panel convivía
 * a veintiocho líneas de distancia con un «Publicado» escrito a mano para el
 * mismo concepto. Traducir en el punto de salida y no en el modelo mantiene el
 * valor de la API tal como es —lo comparan `runTone`, los filtros y los tests—
 * y deja el idioma donde es un asunto de presentación.
 */
export function runLabel(status: string): string {
  switch (status) {
    case "published":
      return "Publicado";
    case "failed":
      return "Fallida";
    case "validating":
      return "Validando";
    case "extracted":
      return "Extraída";
    case "running":
      return "En curso";
    default:
      return status;
  }
}

/** Severidad de una excepción de calidad → texto, por lo mismo. */
export function severityLabel(severity: string): string {
  switch (severity) {
    case "blocking":
      return "Crítica";
    case "warning":
      return "Advertencia";
    case "info":
      return "Informativa";
    default:
      return severity;
  }
}

export function severityTone(severity: string): StatusTone {
  switch (severity) {
    case "blocking":
      return "critical";
    case "warning":
      return "serious";
    default:
      return "neutral";
  }
}
